/**
 * The conversation id of the session the panel is currently on, as a tiny
 * observable. The library owns the session internally; api.js records the id
 * as each handshake resolves, and the control channel (UiControlMount) is
 * keyed on it — so it has to FOLLOW the id across a History pick or a
 * "new conversation" (sessionKey switch), not capture it once at mount.
 *
 * Dependency-free ESM so scripts/test-copilot-conversations.mjs can run the
 * real source under node:test.
 */
let current = null;
const listeners = new Set();

/** The last resolved conversation id, or null before the first handshake. */
export const getConversationId = () => current;

/** Record a newly resolved id; listeners are told only when it actually changes. */
export const setConversationId = (id) => {
  const next = id ?? null;
  if (next === current) return;
  current = next;
  listeners.forEach((listener) => listener(next));
};

/** Follow the id. Returns the unsubscribe function. */
export const subscribeConversationId = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
